import React, { useState } from "react";
import Styles from "./ProgramCard.module.css";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import VerticalTabs from "./VerticalTabs";
import { useTranslation } from "react-i18next";

function ExpiredProgramCard({
	id,
	image,
	name,
	describe,
	cost,
	duration,
	startDate,
	schedule,
}) {
	const [open, setOpen] = useState(false);
	const { t, i18n } = useTranslation();

	const isRtl =
		i18n.language === "ar" || i18n.language === "ku";

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (

		<div
			// className={
			// 	isRtl
			// 		? Styles.cardContainerRtl
			// 		: Styles.cardContainer
			// }

			className={Styles.cardContainer}
		>
			<img
				className={
					isRtl ? Styles.imgCardRtl : Styles.imgCard
				}
				// className={Styles.imgCard}
				src={image}
				alt='card'
			/>

			<h2
				className={isRtl ? Styles.h2Rtl : Styles.h2}

				// className={Styles.h2}
			>
				{name}
			</h2>
			<p
				className={
					isRtl ? Styles.describtionRtl : Styles.describtion
				}
				// className={Styles.describtion}
			>
				{describe}
			</p>
			<p
				className={
					isRtl
						? Styles.paragraphTitleRtl
						: Styles.paragraphTitle
				}
				// className={Styles.paragraphTitle}
			>
				{t("GuideProfile.tripCost")} <span>{cost} $</span>
			</p>
			<p
				className={
					isRtl
						? Styles.paragraphTitleRtl
						: Styles.paragraphTitle
				}
				// className={Styles.paragraphTitle}
			>
				{t("GuideProfile.tripPeriod")}
				<span>
					{duration} {t("GuideProfile.days")}
				</span>
			</p>

			<button
				onClick={handleOpen}
				className={isRtl ? Styles.linkRtl : Styles.link}
				// className={Styles.link}
			>
				{t("GuideProfile.moreDetails")}
			</button>

			<Dialog
				open={open}
				onClose={handleClose}
			>
				<DialogContent>
					<VerticalTabs
						id={id}
						name={name}
						describe={describe}
						cost={cost}
						duration={duration}
						startDate={startDate}
						schedule={schedule}
						state='expired'
					/>
				</DialogContent>
			</Dialog>
		</div>
	);
}

export default ExpiredProgramCard;
